import { Dropdown, Button, Menu, message } from 'antd';
import { SettingOutlined, UserOutlined } from '@ant-design/icons';
import {
  getLocalizedString
} from '@cometchat/chat-uikit-react';

const SettingDropdown = ({
  onClickEditProfile,
}: {
  onClickEditProfile: () => void;
}) => {
  // 处理菜单点击事件
  const handleMenuClick = (e: { key: string }) => {
    if (e.key === 'edit-profile') {
      // 这里可以添加编辑个人资料的逻辑
      onClickEditProfile();
      // 实际应用中可能会导航到编辑页面，例如：
      // history.push('/edit-profile');
    }
  };

  // 定义下拉菜单内容
  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item
        key="edit-profile"
        icon={<UserOutlined />}
      >
        {getLocalizedString('edit_profile')}
      </Menu.Item>
      {/* 可以在这里添加更多菜单选项 */}
      {/* <Menu.Item key="other-option">其他选项</Menu.Item> */}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
      <Button
        icon={<SettingOutlined />}
        size="middle"
        type="text"
        style={{
          fontSize: '16px',
          padding: '4px 8px',
        }}
      />
    </Dropdown>
  );
};

export default SettingDropdown;
